import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import Seo from "@/components/Seo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo title="Team Login" path="/admin/login" />
      <div className="flex min-h-screen items-center justify-center bg-[#133827] px-4">
        <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl sm:p-10">
          <div className="flex items-center gap-2">
            <img src="/bonsai-logo.png" alt="Bonsai Financial" className="h-10 w-auto rounded-lg bg-white px-2 py-1" />
          </div>
          <h1 className="mt-6 font-display text-2xl font-bold text-[#18201B]">Team Login</h1>
          <p className="mt-1 text-sm text-[#526057]">Secure access to the lead dashboard.</p>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="login-submit-btn" className="w-full bg-[#133827] text-white hover:bg-[#0d261a]">
              {loading ? "Signing in…" : "Sign In"}
            </Button>
          </form>
          <div className="mt-4 flex items-center justify-between text-sm">
            <Link to="/forgot-password" className="text-[#2C5E43] hover:underline" data-testid="login-forgot-link">Forgot password?</Link>
            <Link to="/" className="text-[#526057] hover:underline">← Back to site</Link>
          </div>
        </div>
      </div>
    </>
  );
}
